<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconClose_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M16.293 17.707a1 1 0 0 0 1.414-1.414L13.414 12l4.293-4.293a1 1 0 0 0-1.414-1.414L12 10.586 7.707 6.293a1 1 0 0 0-1.414 1.414L10.586 12l-4.293 4.293a1 1 0 1 0 1.414 1.414L12 13.414l4.293 4.293Z"
        clip-rule="evenodd"
    />
</svg>
